fx.ns("shared.popups", class ConfirmUpdateTheme extends shared.popups.BasePersonPopup{
    
    constructor(theme)
    {
        super(theme, fx.get("assets").personSure )
        this.contentWidth = 550;
        this.contentHeight = 200;
    }

    get theme()
    {
        return this.data;
    }

    create()
    {
        super.create();
 
        this.addChild(new fx.components.Text({text:fx.text("Votre album va être refait avec ce thème ?"), className:"title center"}));
        this.addChild(new fx.components.Text({text:fx.text("Si vous aviez effectué des modifications, elles seront perdue."), className:"text center"}));

        this.okButton = new fx.components.Button({label : fx.text("C'est parti !"), type : "filled"});
        this.cancelButton = new fx.components.Button( {label :fx.text("Annuler")} );

        this.addFooterChild(this.cancelButton, {width : 200})
        this.addFooterChild(this.okButton, {width : 200})
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.onConfirm, this.okButton);
        this.on("click", this.close, this.cancelButton);

        this.on("ENTER", this.onConfirm, fx.keyboard);
    }

    onConfirm()
    {
        this.trigger("confirmed", this.theme);
        this.close();
    }

});